import { api } from 'common';
import { LlmModelName } from 'llm-model-registry';

export const llmPromptBlockDefaultConfig = {
  prompt: `Please summarize patient history.
1. What is the patient's chief complaint?
2. What is the patient's past medical history?
`,
  runMode: api.FlowDefinition.RunMode.Live,
  modelName: LlmModelName.notable_default,
  temperature: 0.0,
  maxTokens: 4096,
  topP: 0.3,
  frequencyPenalty: 0,
  responseFormat: [],
};

export const TEMPERATURE_HELPER_TEXT =
  'Lower values (0–0.3) yield consistent, repeatable outputs; higher values increase variation. Range: 0–2.';
